import { render, staticRenderFns } from "./SimpleInvoice.vue?vue&type=template&id=073443e3&scoped=true&"
import script from "./SimpleInvoice.vue?vue&type=script&lang=js&"
export * from "./SimpleInvoice.vue?vue&type=script&lang=js&"
import style0 from "./SimpleInvoice.vue?vue&type=style&index=0&id=073443e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073443e3",
  null
  
)

export default component.exports